import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getDevServerApi} from '../../../apis/devserver/devserver'
import {useEffect} from 'react'

const useQueryDevServer = (size?: number, currentPage: number = 1) => {
    const PAGE_SIZE = size || 10
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.devServer.getDevServer(),
        queryFn: async () => {
            const {data} = await getDevServerApi(PAGE_SIZE, currentPage)
            return data
        },
        refetchOnWindowFocus: false,
    })

    useEffect(() => {
        refetch()
    }, [refetch])

    return {data, refetch}
}

export default useQueryDevServer
